module.exports = __webpack_public_path__ + "img/62exp.42b97b07.jpg";